import { FileSelectField } from '@/components/custom/erp';
import { FormMode } from '@/types/form';

interface FileTabProps {
  formMode: FormMode;
}

const FileTab: React.FC<FileTabProps> = ({ formMode }) => {
  return (
    <div className='space-y-2 p-4'>
      <div className='space-y-1'>
        <FileSelectField label='Chọn files' formMode={formMode} onFileChange={file => console.log(file)} />
      </div>
    </div>
  );
};

export default FileTab;
